const OurServicesList = [
  {
    id: 1,
    title: 'Affordable online courses',
    description: 'Affordable online courses along with learning communities.',
    imgLink: '/images/aboutUs/service-1.svg',
  },
  {
    id: 2,
    title: 'Best in Class/Industry Mentors',
    description: 'Mentors are Youtubers, digital entrepreneurs and content creators.',
    imgLink: '/images/aboutUs/service-2.svg',
  },
  {
    id: 3,
    title: 'Experience Portal',
    description: 'A revolutionary self-paced experience portal.',
    imgLink: '/images/aboutUs/service-3.svg',
  },
  {
    id: 4,
    title: 'On-Demand Courses',
    description:
      'Provide on-demand courses across technologies like data science, machine learning, and AI.',
    imgLink: '/images/aboutUs/service-5.svg',
  },
  {
    id: 5,
    title: 'Innovation Lab for Tech products',
    description:
      'Product development at R&D lab with respect to robotics, drones, and customised products like electronic devices, AI on edge devices.',
    imgLink: '/images/aboutUs/service-6.svg',
  },
];

export default OurServicesList;
